import { isValidDefaultFormat, parse, isValidDate } from '@myap/ui-library/esm/date'
import { isEmpty } from '../../../utils/common'
import { convertToNumberString } from '../../../utils/numbers'

export const RequiredValidation = value =>
  value !== null && value !== undefined && !isEmpty(value) ? undefined : 'Error: Field is required.'
export const RequiredCheckboxValidation = value => (value ? undefined : 'Error: Field is required.')

export const AddRequiredValidation = (isRequired, otherTests = [], isCheckbox = false) => {
  const _validation = isCheckbox ? RequiredCheckboxValidation : RequiredValidation
  return isRequired ? [_validation, ...otherTests] : otherTests
}

export const LengthValidation = len => value =>
  !value || (value && value.length === len) ? undefined : `Error: Field must be ${len} characters.`

export const PositiveNumberValidation = value => {
  const number = parseInt(value)
  return !value || (/^\d+$/.test(value) && number > 0)
    ? undefined
    : 'Error: Value must be a number greater than zero.'
}

export const AlphanumericValidation = value =>
  !value || /^[a-z0-9]+$/i.test(value) ? undefined : 'Error: Field can be letters and numbers only.'

export const SelectAllValidation = maxCount => value => {
  return !value || !maxCount || value.length < maxCount
    ? undefined
    : 'Error: You can not select all values.'
}

export const PhoneValidation = value => {
  const len = value ? value.toString().length : 0
  return !len || (len > 9 && len < 16) ? undefined : 'Error: Invalid phone format.'
}

export const ZipValidation = value => {
  const len = value ? convertToNumberString(value).length : 0
  return !len || len === 9 || len === 5 ? undefined : 'Error: Invalid zip format.'
}

export const NumberValidation = val =>
  !val || /^[1-9]\d*(\.[0-9]{1,2})?$/.test(val) ? undefined : 'Error: Invalid number format.'

export const EmailValidation = value => {
  return isEmpty(value) ||
    /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i.test(
      value
    )
    ? undefined
    : 'Error: Invalid email address.'
}

export const CommentValidation = value =>
  !value || /^[-_.~:, 'A-Za-z0-9]+$/.test(value)
    ? undefined
    : 'Error: Value may only contain alpha numeric characters, space, hyphen, underscore, tilde, period, comma, apostrophe and colon.'

export const CheckDateFormat = value => {
  const DATE_FORMAT = 'YYYY-MM-DD'
  if (!isEmpty(value) && isValidDefaultFormat(value)) {
    const parsedDate = parse(value)
    if (isValidDate(parsedDate)) {
      return undefined
    }
  }
  return `Error: Invalid date format. Must be ${DATE_FORMAT}.`
}

export const CheckDateFormatIfNotEmpty = value =>
  !isEmpty(value) ? CheckDateFormat(value) : undefined

export const ApIdValidation = value => {
  const len = value ? value.length : 0
  return (len === 8 && /^[0123456789UVWXYZ]+$/.test(value)) || !value
    ? undefined
    : 'AP ID must be 8 characters and may only contain numbers and characters U-Z.'
}
